import { LocalStorage } from './../../shared/localstorage.service';
import { GCAttributeValue, AttributeName } from '../../shared/createattribute.model';
import { AddAttributevaluesDialogComponent } from './../add-attributevalues-dialog/add-attributevalues-dialog.component';
import { Component, OnInit, Output } from '@angular/core';
import { MatDialogRef, MatMenuModule, MatFormFieldModule, MatDialog } from '@angular/material';
import { CreateAttributeService } from '../../shared/createattribute.service';
import { AuthenticationService } from '../../shared/authentication.service';

@Component({
  selector: 'app-create-attribute-dialog',
  templateUrl: './create-attribute-dialog.component.html',
  styleUrls: ['./create-attribute-dialog.component.scss']
})
export class CreateAttributeDialogComponent implements OnInit {

  attributeValues = [];

  private attributeValueObject: GCAttributeValue;
  attributeName: string;
  attributeNameId: number;
  private attributeNameObject: AttributeName;

  constructor(public dialog: MatDialog,public createAttributeDialog: MatDialogRef<CreateAttributeDialogComponent>, public service: CreateAttributeService, public auth: AuthenticationService) { }

  ngOnInit() {
  }

  openDialog() {
    
    if(this.attributeNameId == null){
     var attributeNameObj = new AttributeName(this.attributeName,true);
      this.service.createQualityAttribute(attributeNameObj, this.auth.currentState).subscribe(res => {
      
        console.log('created');
        console.log(res);
        var data = JSON.stringify(res);
        this.attributeNameId = parseInt(data);
     
      });
    }
    let dialogRef = this.dialog.open(AddAttributevaluesDialogComponent, {
      width:'400px',
      data: 'This is text'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog closed: ${result}`);
      if(result != 'Cancel'){
          this.attributeValues.push(result);
      }
    })
  }

  OnCloseConfirm(){
    
    console.log(this.attributeName);
    console.log(this.attributeNameId);
    //this.attributeNameObject.IsActive = ;
    // var attributeNameObj = new AttributeName(this.attributeName,true);
    // this.service.createQualityAttribute(attributeNameObj).subscribe(res => {
      
    //   console.log('created');
    //   console.log(res);
    //   var data = JSON.stringify(res);
    //   this.attributeNameId = parseInt(data);
     
    // });
    this.service.getQualityAttributeId(this.attributeName, this.auth.currentState).subscribe((res =>
      {
          console.log(res);
          this.attributeNameId = res['QualityAttributeId'];

          console.log(this.attributeNameId);
      }
    ));

    for(let i=0; i < this.attributeValues.length; i++){
      var attributeValueObj = new GCAttributeValue(this.attributeNameId, this.attributeValues[i]);
      this.service.createQualityAttributeValues(attributeValueObj, this.auth.currentState).subscribe(() => {
       
        console.log('created');
        
    });;
    }
    this.createAttributeDialog.close();
  }

 
  OnCloseCancel() {
    this.createAttributeDialog.close('Cancel');
  }

}
